import React from 'react';
import GoogleMapReact from 'google-map-react';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';
import mapContext from '../../../contexts/map-context';
import SearchInThisAreaButton from '../SearchThisAreaButton/SearchInThisAreaButton';
import { generateMapMarkerList } from '../MapMarkerList/generateMapMarkerList';
import { MapContainer } from './Map.styled';
import {
  DEFAULT_CENTER_COORDINATES,
  DEFAULT_ZOOM,
  getBootstrapURLKeys,
  getMapOptions,
} from './MapUtils';
import {
  useLogger,
  useOnChangeDealerId,
  useOnChangeDealerList,
  useOnChangeHash,
} from './Map.hooks';
import {
  handleGoogleApiLoad,
  handleMapChange,
  handleMapClick,
  handleMapDrag,
  handleMapDragEnd,
} from './Map.handlers';

export default function Map() {
  const { marketGoogleKey, locale, mapZoom, mapCenterCoordinates } = mapContext.useMapState();

  const isMobileScreen = useIsMobileScreen();
  const onMapDragEnd = handleMapDragEnd();
  const onMapDrag = handleMapDrag();
  const onMapChange = handleMapChange();
  const onMapClick = handleMapClick();
  const onGoogleApiLoaded = handleGoogleApiLoad();

  useLogger();
  useOnChangeDealerList();
  useOnChangeDealerId();
  useOnChangeHash();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  const key = isMobileScreen ? mapCenterCoordinates.lat : 'map';

  return (
    <MapContainer data-test-id="map-component">
      <>
        <SearchInThisAreaButton />

        <GoogleMapReact
          key={key}
          zoom={mapZoom}
          defaultCenter={DEFAULT_CENTER_COORDINATES}
          defaultZoom={DEFAULT_ZOOM}
          center={mapCenterCoordinates}
          onChange={onMapChange}
          onDrag={onMapDrag}
          onDragEnd={onMapDragEnd}
          onClick={onMapClick}
          onGoogleApiLoaded={onGoogleApiLoaded}
          options={getMapOptions(isMobileScreen)}
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={getBootstrapURLKeys(marketGoogleKey, locale.language)}
          data-test-id="google-map-react"
        >
          {generateMapMarkerList()}
        </GoogleMapReact>
      </>
    </MapContainer>
  );
}
